"use client";

import React from "react";
import { Box, Container, Typography, Chip } from "@mui/material";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import "../app/globals.css";
import { IMAGES } from "../constants/images";
import NextLink from "next/link";
const EvaluateTalent = () => {
  const router = useRouter();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      sx={{
        width: "100%",
        // mb: { xs: "-5%", lg: "-5%" },
        ml: { xs: "-3%", sm: "-2%", md: "0" },
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container
        maxWidth="xxl"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#F4ECFF",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: { xs: 2, sm: 2.5, md: 4, lg: 8 },
            background: "#F4ECFF",
            borderRadius: { xs: "16px", sm: "18px", md: "24px" },
            mt: "2%",
            mb: "2%",
            padding: {
              xs: "24px 20px",
              sm: "32px 28px",
              md: "48px 40px",
              lg: "80px 60px",
            },
            overflow: "hidden",
            maxWidth: "xl",
          }}
        >
          {/* Left Content */}
          <Box
            sx={{
              flex: 1,
              maxWidth: { xs: "100%", md: "48%" },
              display: "flex",
              flexDirection: "column",
              alignItems: isArabic ? "flex-start" : "flex-start",
            }}
          >
            <Chip
              label={t("evaluateTalent.chip")}
              sx={{
                backgroundColor: "transparent",
                border: "1px solid #0206174D",
                mb: { xs: 1.5, sm: 2, md: 3, lg: 4 },
                color: "#818E98",
                fontSize: { xs: "10px", sm: "11px", md: "13px", lg: "16px" },
                fontWeight: "500",
                textTransform: "capitalize",
                px: { xs: 0.4, sm: 0.5, md: 0.6, lg: 0.7 },
                py: { xs: 0.8, sm: 1, md: 1.5, lg: 2.3 },
                fontFamily: "var(--font-outfit)",
                borderRadius: "40px",
              }}
            />

            <Typography
              variant="h1"
              component="h2"
              sx={{
                fontSize: {
                  xs: "22px",
                  sm: "26px",
                  md: "36px",
                  lg: "40px",
                  xl: "52px",
                },
                fontWeight: "700",
                mb: { xs: 1.5, sm: 2, md: 2.5, lg: 3 },
                lineHeight: 1.2,
                fontFamily: "var(--font-plusjakarta)",
                color: "#000000",
                textAlign: isArabic ? "right" : "left",
              }}
            >
              {t("evaluateTalent.title1")}
              <span style={{ color: "#9048FB" }}>
                {t("evaluateTalent.titleHighlight1")}
              </span>
              {t("evaluateTalent.title2")}
              <span style={{ color: "#9048FB" }}>
                {t("evaluateTalent.titleHighlight2")}
              </span>
              {t("evaluateTalent.title3")}

            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "rgba(2, 6, 23, 0.65)",
                mb: { xs: 2, sm: 2.5, md: 3, lg: 4 },
                fontSize: {
                  xs: "13px",
                  sm: "14px",
                  md: "15px",
                  lg: "15px",
                  xl: "17px",
                },
                maxWidth: "95%",
                fontWeight: "400",
                lineHeight: 1.7,
                fontFamily: "var(--font-outfit)",
                textAlign: isArabic ? "right" : "left",
              }}
            >
              {t("evaluateTalent.subtitle")}
            </Typography>

            <NextLink href="/free-trial-of-ai-recruiting-tool" passHref legacyBehavior>
              <Chip
                component="a"
                clickable
                label={t("evaluateTalent.cta")}
                sx={{
                  backgroundColor: "#000",
                  color: "#fff",
                  border: "1px solid #fff",
                  mb: { xs: 2, sm: 2.5, md: 0 },
                  fontSize: { xs: "11px", sm: "12px", md: "14px", lg: "16px" },
                  fontWeight: "500",
                  textTransform: "capitalize",
                  px: { xs: 0.6, sm: 0.7, md: 0.9, lg: 1 },
                  py: { xs: 1.5, sm: 1.8, md: 2.2, lg: 2.9 },
                  fontFamily: "var(--font-outfit)",
                  borderRadius: "40px",
                  width: { xs: "100%", sm: "auto" },
                  display: { xs: "flex", sm: "inline-flex" },
                  justifyContent: "center",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.02)",
                    backgroundColor: "#775CE5",
                  },
                }}
              />
            </NextLink>
          </Box>

          {/* Right Content - Image */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              position: "relative",
              width: { xs: "100%", md: "52%" },
              minHeight: { xs: "200px", sm: "250px", md: "380px", lg: "500px" },
              mr: isArabic ? 0 : { xs: 0, sm: 0, md: -4, lg: -10 },
              ml: isArabic ? { xs: 0, sm: 0, md: -4, lg: -10 } : 0,
              mb: { xs: 0, sm: 0, md: -5, lg: -10 },
            }}
          >
            <Box sx={{ position: "relative", width: "100%", height: "auto" }}>
              <Image
                src={IMAGES.EVALUATE_TALENT_IMG}
                alt="Proprietary AI evaluation engine analyzing 17+ data points in best recruiting automation software"
                width={1100}
                height={800}
                quality={100}
                unoptimized
                style={{
                  objectFit: "contain",
                  width: "100%",
                  height: "auto",
                }}
              />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default EvaluateTalent;
